import type { AllRouteEndpoints } from "../routeTypes";
export const engagementUpdateFeatureFlagRolloutArchivedStateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/:app_group_id/feature_flag_limits",
  "/engagement/:app_group_id/has_feature_flags",
  "/engagement/:app_group_id/feature_flags_info",
  "/engagement/feature_flag_rollouts_data",
  "/engagement/feature_flag_rollouts_data/:feature_flag_bson_id/:app_group_id",
  "/engagement/:app_id/feature_flags_eligibility/:user_id/:device_id",
];
